import AuthenticatedController from './AuthenticatedController';
import { TEMPLATES, TEMPLATES_BY_ID, TEMPLATES_VERIFY } from '@mm/api-routes';
import { TemplateModel } from '../model/TemplateModel';
import { Pagination } from '../store-interfaces';

export class TemplatesController extends AuthenticatedController {
  static getAll(
    sample: boolean,
    page: number,
    perPage: number,
  ): Promise<{ pagination: Pagination; templates: TemplateModel[] }> {
    return super.get(TEMPLATES, { sample, page, per_page: perPage });
  }

  static verifyCodeExistance(code: string): Promise<TemplateModel> {
    return super.get(TEMPLATES_VERIFY, { ref: code });
  }

  static getById(templateId: number): Promise<TemplateModel> {
    return super.get(TEMPLATES_BY_ID(templateId));
  }

  static create(
    botId: number,
    name: string,
    description: string,
    assetId?: string,
    async?: boolean,
  ): Promise<TemplateModel> {
    return super.post(TEMPLATES, {
      bot_id: botId,
      name,
      description,
      asset_id: assetId,
      async,
    });
  }

  static update(
    templateId: number,
    name: string,
    description: string,
    assetId?: string,
  ): Promise<{ template: TemplateModel }> {
    return super.put(TEMPLATES_BY_ID(templateId), {
      id: templateId,
      name,
      description,
      asset_id: assetId,
    });
  }

  static delete(templateId: any): Promise<{ ok: boolean }> {
    return super.delete(TEMPLATES_BY_ID(templateId), { id: templateId });
  }
}
